import { writable, readable } from 'svelte/store';
import { Stack } from '@datastructures-js/stack';

export const selectedPreview = writable();
export const roi = writable();
export const maximumVolume = writable();
export const finalFdkSettings = writable();
export const canvasSize = writable(768);
export const lastPreviewImageIndex = writable(31);
export const lastCentershiftPreviewImageIndex = writable();
export const lastBeamhardCuppingPreviewImageIndex = writable(0);
export const centershiftGapStack = writable(new Stack());
export const zoom = writable(1);
export const offset = writable({ x: 0, y: 0 });
export const histogramThreshold = writable({ min: 0, max: 255 });
export const newlyRequestedCentershiftPreviewSlices = writable(new Set());
export const newlyRequestedBeamhardCuppingPreviewSlices = writable(new Set());
export const USE_IMAGE_SMOOTHING = readable(false);
